/** @jsxImportSource @emotion/react */

interface ChevronIconProps {
  isOpen: boolean
  size?: number
  color?: string
}

const ChevronIcon = ({
  isOpen,
  size = 24,
  color = '#797B7E',
}: ChevronIconProps) => {
  if (isOpen) {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          d='M16.59 8.29501L12 12.875L7.41 8.29501L6 9.70501L12 15.705L18 9.70501L16.59 8.29501Z'
          fill={color}
        />
      </svg>
    )
  }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M9.70498 6L8.29498 7.41L12.875 12L8.29498 16.59L9.70498 18L15.705 12L9.70498 6Z'
        fill={color}
      />
    </svg>
  )
}

export default ChevronIcon
